import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress AudioContext and Script error overlay in development
if (process.env.NODE_ENV === 'development') {
  const origError = window.onerror;
  window.onerror = function(msg, source, lineno, colno, error) {
    if (msg === 'Script error.' || (typeof msg === 'string' && msg.includes('AudioContext'))) {
      return true; // suppress
    }
    return origError ? origError(msg, source, lineno, colno, error) : false;
  };
  window.addEventListener('unhandledrejection', (e) => {
    if (e.reason && e.reason.message && e.reason.message.includes('user gesture')) {
      e.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
